import React from "react";
import { useEffect, useState, ChangeEvent } from "react";


function PaginationI({ itemsPerPage, totalItems, paginate }) {
    const pageNumbers = Math.ceil(totalItems / itemsPerPage);

    const [currentPage, setCurrentPage] = useState(1);

    const handlePageClick = (number) => {
        setCurrentPage(number);
        paginate(number);
    };

    if (pageNumbers <= 1) {
        return null;
    }
    return <div>

        < ul className="pagination pagination--small" >
            < li className="pagination__item pagination__arrow" >
                <button
                    onClick={() => handlePageClick(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    {/* › */}

                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Leading Icon">
                            <path id="Icon" d="M10.5 12L6.5 8L10.5 4" stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            </path></g></svg>
                </button>
            </li >

            {
                [...Array(pageNumbers)].map((_, i) => (
                    <li
                        key={i}
                        className={`pagination__item ${currentPage === i + 1 ? "pagination__item--active" : ""}`}
                    >
                        <button onClick={() => handlePageClick(i + 1)}>
                            {i + 1}
                        </button>
                    </li>
                ))
            }

            <li className="pagination__item pagination__arrow">
                <button
                    onClick={() => handlePageClick(prev => Math.min(prev + 1, pageNumbers))}
                    disabled={currentPage === pageNumbers}
                >
                    {/* ‹ */}
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Leading Icon">
                            <path id="Icon" d="M6.5 12L10.5 8L6.5 4" stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            </path></g></svg>
                </button>
            </li>
        </ul >
    </div>


}
export default PaginationI;